import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { setTokenProvider } from '@/utils/apiClient';

const audience = import.meta.env.VITE_AUTH0_AUDIENCE;

const TokenProviderSetup = () => {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();

  useEffect(() => {
    if (isAuthenticated) {
      setTokenProvider(async () => {
        try {
          const token = await getAccessTokenSilently({
            authorizationParams: {
              audience: audience,
            },
          });
          return token;
        } catch (error) {
          if (error && typeof error === 'object' && 'error' in error && error.error === 'consent_required') {
            window.location.href = '/';
          }
          throw error;
        }
      });
    }
  }, [getAccessTokenSilently, isAuthenticated, user]);

  return null;
};

export default TokenProviderSetup;
